import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import FilterListIcon from "@mui/icons-material/FilterList";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import defaultt from "../../assets/images/default.png";
import { RightOutlined } from "@ant-design/icons";
import axios from "axios";
import NotFound from "../../components/SharedModule/NotFound";
import { useSelector } from "react-redux";

export default function Stock() {
  
  const newHost = "https://estbn.com/EstbnNew/public/api/";

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  // const newHeaders = {
  //   Authorization: `Bearer 1|uXWWHVAxUbLR94IuQ07nZUT5306vlnjfGFo4AUoR16bcf002`,
  // };

  const [products, setProducts] = useState([]);

  const [productsCount, setProductsCount] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedCategories, setSelectedCategories] = useState([]);

  const [categories, setCategories] = useState([]);

  const [showFilterDropdown, setShowFilterDropdown] = useState(false);

  const navigate = useNavigate();

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/products-with-variations`,
        {
          headers: newHeaders,
        }
      );
      console.log(response.data.data);
      setProductsCount(response.data.data.product_count);
      setProducts(response.data.data.products);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      field: "Reference",
      headerName: "Reference No.",
      flex: 1.4,
      minWidth: 180,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            textAlign: "center",
            lineHeight: "18px",
            fontWeight: 600,
          }}
        >
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "Name",
      headerName: "Item Name",
      flex: 1.1,
      minWidth: 120,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent:'center',
            alignItems: "center",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            lineHeight: "18px",
          }}
        >
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "Category",
      headerName: "Category",
      flex: 0.9,
      minWidth: 90,
      renderCell: (params) => {
        const { name, imageUrl } = params.value;
        return (
          <div className="d-flex justify-content-center align-items-center h-100">
            <img
              src={imageUrl}
              alt={`${name} logo`}
              style={{
                width: 20,
                height: 20,
                objectFit: "cover",
              }}
            />
            <span className="ms-2">{name}</span>
          </div>
        );
      },
    },
    {
      field: "Unit",
      headerName: "Unit",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Quantity",
      headerName: "Quantity",
      flex: 0.7,
      minWidth: 70,
    },
    {
      field: "Reorder",
      headerName: "Reorder Point",
      flex: 1.1,
      minWidth: 100,
      renderCell: (params) => {
        const { name, color } = params.value || {};
        return (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                backgroundColor: color || "#ccc",
              }}
            ></div>
            <span className="ms-2">{name || "Unknown"}</span>
          </div>
        );
      },
    },
    {
      field: "Model",
      headerName: "Model",
      flex: 0.8,
      minWidth: 90,
    },
    {
      field: "Manufacturer",
      headerName: "Manufacturer",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.6,
      minWidth: 60,
      renderCell: (params) => {
        const handleNavigate = (event) => {
          event.stopPropagation();
          navigate(`/stock/${params.row.id}`);
        };

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              onClick={handleNavigate}
              color="default"
              aria-label="navigate"
              style={{ width: "100%" }}
              size="small"
            >
              <RightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const filteredRows = products
    .filter((product) => {
      const matchesSearch =
        product.sku.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product?.product?.category?.name
          .toLowerCase()
          .includes(searchTerm.toLowerCase());

      const matchesCategory =
        selectedCategories.length === 0 ||
        selectedCategories.includes(product?.product?.category?.name);

      return matchesSearch && matchesCategory;
    })
    .map((product) => ({
      id: product.id,
      Reference: product.reference,
      Name: product.name,
      Category: {
        name: product?.product?.category?.name,
        imageUrl:
          product?.product?.category?.image_url !== null
            ? `https://estbn.com/EstbnNew/public${product?.product?.category?.image_url}`
            : defaultt,
      },
      Unit: product.unit?.name,
      Quantity: product.quantity,
      Reorder: {
        name: product?.stock_status,
        color: product?.stock_status_color,
      },
      Model: product?.product?.brand?.name,
      Manufacturer: product?.product?.brand?.manufacturer?.name || "Undefined",
      Actions: "",
    }));

  const paginationModel = { page: 0, pageSize: 10 };

  useEffect(() => {
    getProducts();
  }, []);

  useEffect(() => {
    const uniqueCategories = [
      ...new Set(
        products.map((p) => p?.product?.category?.name).filter(Boolean)
      ),
    ];
    setCategories(uniqueCategories);
  }, [products]);

  return (
    <>
      {/* add product modal  */}
      <div className="m-4">
        {/* stock header */}
        <div className="notifications-display">
          <div className="d-flex justify-content-center justify-content-md-start align-items-center">
            <p className="fs-5 my-0 fw-bold">Products List</p>
            <p className=" bg-black text-white my-0 mx-2 px-2 bg-opacity-75 rounded-2">
              {productsCount}
            </p>
          </div>
        </div>
        {/* stock search */}
        <div className="notif-search d-flex justify-content-center justify-content-md-end align-items-center my-3">
          {/* search by text  */}
          <div>
            <FormControl
              sx={{ width: "37ch" }}
              className="mx-2 mx-md-3"
              variant="filled"
            >
              <InputLabel htmlFor="outlined-adornment-password">
                Search by item code, name, category
              </InputLabel>
              <OutlinedInput
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                id="outlined-adornment-password"
                type={"text"}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton edge="end">{<SearchIcon />}</IconButton>
                  </InputAdornment>
                }
                label="Search by ID, name, category"
              />
            </FormControl>
          </div>
          {/* filteration  */}
          <div className="position-relative border border-1 p-2 mb-3 rounded-3">
            <IconButton onClick={() => setShowFilterDropdown((prev) => !prev)}>
              <FilterListIcon />
            </IconButton>
            {showFilterDropdown && (
              <div
                className="position-absolute mt-2 rounded shadow"
                style={{
                  width: "240px",
                  right: 0,
                  backgroundColor: "#fff",
                  border: "1px solid #ddd",
                  padding: "16px",
                  zIndex: 10,
                }}
              >
                <p className="fw-bold mb-2">Filter by Category</p>
                <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                  {categories.map((cat) => (
                    <label
                      key={cat}
                      className="d-flex align-items-center mb-2"
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                        gap: "8px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedCategories.includes(cat)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedCategories((prev) => [...prev, cat]);
                          } else {
                            setSelectedCategories((prev) =>
                              prev.filter((c) => c !== cat),
                            );
                          }
                        }}
                      />
                      <span>{cat}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        {/* stock data */}
        <div>
          {filteredRows && filteredRows.length > 0 ? (
            <div className="scrollable-table-wrapper">
              <div>
                <Paper sx={{ width: "100%" }}>
                  <DataGrid
                    rows={filteredRows}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5, 10 , 20 , 50]}
                    checkboxSelection
                    sx={{
                      border: 0,
                      "& .MuiDataGrid-cell": {
                        display: "flex",
                        justifyContent:'center',
                        alignItems: "center",
                      },
                    }}
                    slotProps={{
                      pagination: {
                        sx: {
                          justifyContent: "center",
                          display: "flex",
                          alignItems: "center",
                        },
                      },
                    }}
                  />
                </Paper>
              </div>
            </div>
          ) : (
            <div
              className="d-flex justify-content-center align-items-center w-100"
              style={{ minHeight: "300px" }}
            >
              <NotFound
                paragraphText={
                  "No Products Yet. All your Brands will appear here once you get started."
                }
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
